'use client';

import styles from './LotteryDrawButton.module.scss';

type Props = {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  color?: string;
};

function LotteryDrawButton({ children, onClick, disabled = false, color = 'black' }: Props) {
  return (
    <button
      className={`${styles.actionButton}`}
      type='button'
      onClick={onClick}
      style={generateStyle({ color, disabled })}
      disabled={disabled}
      data-testid='draw-lots-button'
    >
      {children}
    </button>
  );
}

const generateStyle = ({ color, disabled }: Pick<Props, 'color' | 'disabled'>): React.CSSProperties => {
  if (disabled) {
    return {
      borderColor: 'var(--color-pinkishgray)',
      background: 'var(--color-pinkishgray)',
    };
  }
  // 色に応じてグラデーション
  switch (color) {
    case 'primary':
      return {
        border: 'none',
        background: 'linear-gradient(to top, var(--color-gradationprimary), var(--color-primary))',
      };
    default:
      return {
        border: `var(--color-${color})`,
        background: `var(--color-${color})`,
      };
  }
};

export default LotteryDrawButton;
